module.exports = __webpack_public_path__ + "static/media/CAT.682b1f9e.png";